<template>
    <div class="row">
        <div class="col-sm-8 col-xl-9">
            <strong><span class="text-muted small">напоминание</span> <span class="badge badge-primary">{{item.data.user.name}}</span></strong>
            <span class="small" :class="{badge: is_expired, 'badge-danger': is_expired}" v-if="!item.data.done">истекает {{item.data.expires_at}}</span>
            <span class="text-muted small" v-if="item.data.done">завершено</span>
            <button :disabled="done_process" @click="todo()" v-if="!item.data.done" class="btn badge btn-success">Завершить</button>
        </div>
        <div class="col-sm-4 col-xl-3">
            <div class="float-sm-right request-action-item-right pr-2">
                <!--            <span v-if="item.data.status === 'error'" class="small text-danger">Ошибка</span>-->
                <span class="small">{{item.data.created_at}}</span>
            </div>
        </div>
        <div class="col-12">
            <p class="text-pre-wrap">{{item.data.text}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RequestHistoryActionReminder",
        props: ['item'],
        data: () => ({
            done_process: false,
        }),
        computed: {
            is_expired () {
                return (new Date() - new Date(this.item.data.expires_at)) > 0;
            },
        },
        methods: {
            todo() {
                this.done_process = true;
                let self = this;
                axios.get('/api/request_reminders/' + self.item.data.id + '/done').then(function () {
                    self.done_process = false;
                    self.item.data.done = 1;
                    self.$bus.$emit('request_reminder:done');
                });
            }
        }
    }
</script>

<style scoped>

</style>
